import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { MenuItem } from 'primeng/api';
import { TabMenuModule } from 'primeng/tabmenu';

import { TachographVehiclesFilesStatusComponent } from './vehicles/tachograph-vehicles-files-status.component';
import { TachografConfigComponent } from './tachograf-config/tachograf-config.component';
import { TachographDriversFilesStatusComponent } from './drivers/tachograph-drivers-files-status.component';
import { TachographFilesDddVehiclesComponent } from './ddd-vehicles/tachograph-files-ddd-vehicles.component';
import { TachographFilesDddDriversComponent } from './ddd-drivers/tachograph-files-ddd-drivers.component';

const imports = [
  CommonModule,
  TranslateModule,
  TachographVehiclesFilesStatusComponent,
  TabMenuModule,
  TachografConfigComponent,
  TachographDriversFilesStatusComponent,
  TachographFilesDddVehiclesComponent,
  TachographFilesDddDriversComponent,
];

enum View {
  VehiclesStatus = 1,
  DriversStatus = 2,
  Config = 3,
  FilesDDDVehicles = 4,
  FilesDDDDriver = 5,
}

@Component({
  selector: 'app-tachograph-files-status',
  standalone: true,
  imports,
  templateUrl: './tachograph-files-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./tachograph-files-status.component.scss'],
})
export class TachographFilesStatusComponent {
  private translate = inject(TranslateService);

  public readonly VIEW = View;
  public readonly TABS: (MenuItem & { type: View })[] = [
    {label: this.translate.instant('vehicleStatus'), command: () => this.onChangeView(View.VehiclesStatus), type: View.VehiclesStatus },
    {label: this.translate.instant('driverStatus'), command: () => this.onChangeView(View.DriversStatus), type: View.DriversStatus },
    {label: this.translate.instant('filesDDDVehicles'), command: () => this.onChangeView(View.FilesDDDVehicles), type: View.FilesDDDVehicles },
    {label: this.translate.instant('filesDDDDrivers'), command: () => this.onChangeView(View.FilesDDDDriver), type: View.FilesDDDDriver },
    {label: this.translate.instant('configuration'), command: () => this.onChangeView(View.Config), type: View.Config },
  ];

  public activeItem: MenuItem;
  public initalSearchValueFilesDDD: string;

  public activeView = signal<View>(View.VehiclesStatus);

  constructor() {
    this.activeItem = this.findTabByView(this.activeView());
  }

  private findTabByView(view: View): MenuItem {
    return this.TABS.find(tab => tab.type === view)!;
  }

  private onChangeView(view: View): void {
    this.activeView.set(view);
    this.activeItem = this.findTabByView(view);
  }

  public openFilesDDDWithInitValue(initSearchValue: string, type: View): void {
    this.initalSearchValueFilesDDD = initSearchValue;
    this.onChangeView(type);

    setTimeout(() => this.initalSearchValueFilesDDD = '', 0);
  }

}
